"use client";

import { Button } from "@/components/ui/button";
import { inputVariants } from "@/components/inputs/text-input";
import { InfoSolid } from "@/components/icons/info-solid";
import { cn } from "@/lib/utils";

interface TrackShipmentStartProps {
  trackingId: string;
  onTrackingIdChange: (value: string) => void;
  onTrack: () => void;
  isLoading?: boolean;
  errorMessage?: string;
}

export function TrackShipmentStart({
  trackingId,
  onTrackingIdChange,
  onTrack,
  isLoading,
  errorMessage,
}: TrackShipmentStartProps) {
  return (
    <div
      className="flex flex-col items-center gap-6 px-5 py-7 sm:px-10 sm:py-9 lg:px-14 lg:py-10"
      id="track-start"
    >
      <div className="flex flex-col items-center gap-4 text-center">
        <h3 className="text-lg sm:text-xl lg:text-2xl font-semibold text-primary-text-900">
          Enter Your Tracking Number
        </h3>

        <div className="w-full max-w-[460px] flex flex-col gap-3">
          <label htmlFor="tracking-id" className="sr-only">
            Tracking number
          </label>
          <input
            id="tracking-id"
            value={trackingId}
            onChange={(event) => onTrackingIdChange(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                event.preventDefault();
                onTrack();
              }
            }}
            placeholder="E.g 12345"
            className={cn(
              inputVariants({ variant: "primary", radius: "full", height: "lg" }),
              "text-sm sm:text-base text-primary-900 placeholder:text-primary-text-300 px-6",
            )}
          />
          {errorMessage && (
            <p className="text-xs sm:text-sm text-alert-500 text-left">{errorMessage}</p>
          )}
          <div className="flex items-start justify-center gap-2 text-[11px] sm:text-xs text-primary-text-500 rounded-full border  bg-primary-50 px-1 py-1">
            <InfoSolid className="h-4 w-4 text-primary-600" />
            <span>
              Please ensure you are using a correct tracking number in order to avoid errors.
            </span>
          </div>
        </div>
      </div>

      <Button
        onClick={onTrack}
        radius="full"
        size="xl"
        disabled={isLoading}
        className="w-full max-w-[340px] mx-auto h-12 sm:h-14 text-base sm:text-lg bg-primary-700 text-white hover:bg-primary-800"
      >
        {isLoading ? "Tracking..." : "Track"}
      </Button>
    </div>
  );
}

